import e from "../_virtual/_plugin-vue_export-helper.js";
import { Fragment as t, createElementBlock as n, createElementVNode as r, openBlock as i } from "vue";
//#region src/icons-legacy/shirt-24.vue
var a = {};
function o(e, a) {
	return i(), n(t, null, [a[0] ||= r("path", {
		d: "M6.49994 10.4997L6.5 20.4998C6.5 20.8145 6.64793 21.1099 6.92158 21.2654C7.68014 21.6963 9.43829 22.5 12 22.5C14.5617 22.5 16.3199 21.6963 17.0784 21.2654C17.3521 21.1099 17.5 20.8145 17.5 20.4998L17.4999 10.4997C17.4999 9.94744 17.9476 9.49972 18.4999 9.49972H21.7192C22.1781 9.49972 22.5781 9.18743 22.6894 8.74227L23.2934 6.32622C23.4125 5.85005 23.1684 5.35787 22.7172 5.16452L16.6998 2.58562C16.5922 2.53953 16.4665 2.59428 16.4191 2.70126C16.1213 3.37365 14.9466 5.5 12 5.5C9.05337 5.5 7.87871 3.37364 7.58092 2.70126C7.53354 2.59428 7.40776 2.53953 7.30021 2.58562L1.28279 5.16452C0.831651 5.35786 0.587522 5.85005 0.706577 6.32622L1.31065 8.74228C1.42196 9.18743 1.82193 9.49972 2.28079 9.49972H5.49994C6.05222 9.49972 6.49993 9.94743 6.49994 10.4997Z",
		fill: "none",
		stroke: "currentColor"
	}, null, -1), a[1] ||= r("path", {
		d: "M16.5 2.5C16.5 2.5 14.5 3 12 3C9.5 3 7.5 2.5 7.5 2.5",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round"
	}, null, -1)], 64);
}
var s = /*#__PURE__*/ e(a, [["render", o]]);
//#endregion
export { s as default };
